import React from 'react';
import { UncontrolledTable } from '~/components';
import usePatient from '~/utils/patient/hook';
import { TableFilterIdentitySource } from '~/components/Filters';
import { MatchStatus } from '~/utils/const/identity';
import { parse, format } from 'date-fns';

const immunTransform = (immunizations) => {
  immunizations.map((immunization) => {
    const formattedImmunization = immunization;
    if (formattedImmunization?.attributes?.date) {
      let dates = formattedImmunization.attributes.date.split(', ');
      dates = dates.map((d) => format(parse(d), 'MM-DD-YYYY'));
      formattedImmunization.attributes.date = dates.join(', ').replaceAll('-', '/');
    }
    return formattedImmunization;
  });
  return immunizations;
};

const Immunizations = () => {
  const [, { sacwisPersonId: sacwisId }] = usePatient();

  return (
    <>
      <UncontrolledTable
        name="immunizations"
        dataTransform={immunTransform}
        className="mx-4"
        endpoint={{
          url: 'data/public/list-view-cs-tbl-immunization',
          params: {
            sacwis_id: sacwisId,
            match_status_id: MatchStatus.Approved,
            'all-data': 1,
          },
        }}
        defaultSorted={[{ id: 'vaccination' }]}
        columns={[
          {
            id: 'vaccination',
            Header: 'Vaccination',
            accessor: 'attributes.vaccination',
          },
          {
            id: 'date',
            Header: 'Date',
            accessor: 'attributes.date',
          },
          {
            id: 'sourceDescription',
            Header: 'Reporting Healthcare Institution',
            accessor: 'attributes.sourceDescription',
            Filter: d => <TableFilterIdentitySource {...d} />,
          },
        ]}
      />

      <p>
        <a
          href="https://www.cdc.gov/vaccines/imz-schedules/child-easyread.html?CDC_AAref_Val=https://www.cdc.gov/vaccines/schedules/easy-to-read/child-easyread.html"
          target="_blank"
          rel="noopener noreferrer"
        >
          CDC Immunization Schedule
        </a>
      </p>
    </>
  );
};

export default Immunizations;
